// module exports must be returned from runtime so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/@babel/polyfill/lib/index.js");
return __webpack_require__("./src/index.mjs");
